if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', class ProductUpsells extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback () {
      this.tabButtons = this.querySelectorAll('.js-tab-button')
      this.tabPanels = this.querySelectorAll('.js-tab-panel')

      this.tabButtons.forEach(button => button.addEventListener('click', this.handleTabClick.bind(this)))
    }


    handleTabClick (e) {
      const index = e.target.dataset.index

      this.tabButtons.forEach(button => {
        button.classList[button.dataset.index === index ? 'add' : 'remove']('is-active')
      })

      this.tabPanels.forEach(panel => {
        if (panel.dataset.index === index) {
          panel.classList.add('is-visible')

          setTimeout(() => {
            panel.classList.add('is-active')
          })
        } else {
          panel.classList.remove('is-active')

          setTimeout(() => {
            panel.classList.remove('is-visible')
          })
        }
      })
    }
  });
}
